import { Component, OnDestroy, OnInit } from '@angular/core';
import { CardInputsAbstractInput } from '../card-inputs.abstract-input';
import { AvailableBrands } from '../../shared/enums/AvailableBrands';
import { FormControl, Validators } from '@angular/forms';
import { CreditCardValidator } from 'ng-betalabs-creditcard';

@Component({
    'selector': 'card-inputs-number',
    'templateUrl': './card-inputs.number.component.html',
    'providers': [],
    'styleUrls': []
})
export class CardInputsNumberComponent extends
    CardInputsAbstractInput implements OnInit, OnDestroy {
    public brand = 'unknown';
    public brandControl: FormControl;

    ngOnInit() {
        this.form.addControl('number', this.control = new FormControl(
            '',
            [Validators.required, CreditCardValidator.validateCCNumber]
        ));
        this.form.addControl('brand', this.brandControl = new FormControl(
            '',
            [Validators.required]
        ));
    }
    ngOnDestroy() {
        this.form.removeControl('number');
        this.form.removeControl('brand');
    }

    /**
     * Fill brand at model instance using element class list
     **/
    public fillBrand() {
        const fieldId = 'card-number-' + this.index + '-' + this.cardIndex;
        const $field = document.getElementById(fieldId);

        if ($field !== null) {
            this.brand = $field.className
                .split(' ')
                .filter((className) => AvailableBrands.indexOf(className) >= 0)
                .shift();

            this.brandControl.setValue(this.brand);
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/card-inputs/number/card-inputs.number.component.ts